export default {
  path: 'excavation-service/work-orders/inactive',
  name: 'ExcavationInactiveWorkOrders',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ExcavationWorkOrdersIndex')
}
